module.exports = __webpack_public_path__ + "img/add-search-condition-hover.9ea9e343.svg";